module.exports = __webpack_public_path__ + "static/media/cardback.6bf3b903.png";